import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'mt-page-not-found',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './page-not-found.ui-component.html',
  styleUrl: './page-not-found.ui-component.scss',
})
export class PageNotFoundUiComponent {}
